import { getIsoDatestampDaysIntoThePast } from '../../helpers/dateTimeHelpers';

export const DefaultTransactionsPageLink = (): string =>
  `/transactions`;
